'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, SkeletonBar } from '@petsmart-ui/sparky';
import cn from 'classnames';
import { useIsMounted, usePageLayout, useStore } from '@libs/common-next';
import { trackSelectStore } from './analytics';
import { getStoreLocatorDetails } from './store-locator.utils';
import './store-locator.scss';
const FIND_A_STORE_LABEL = 'Find a Store';
const LOADING_STORE_LABEL = 'Loading store';
export function StoreLocator() {
  const $ = _c(23);
  const {
    selectedStore,
    selectedStoreId
  } = useStore();
  const {
    isMounted
  } = useIsMounted();
  const store = selectedStore.data;
  const isStoreLoading = !isMounted || Boolean(selectedStoreId && selectedStore.isPending);
  const {
    setStoreDrawerOpen
  } = usePageLayout();
  let t0;
  if ($[0] !== store) {
    t0 = store ? getStoreLocatorDetails(store) : {
      hoursLabel: "",
      hoursStatus: "unavailable" as const
    };
    $[0] = store;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    hoursLabel,
    hoursStatus
  } = t0;
  const storeLabel = store?.Name ?? FIND_A_STORE_LABEL;
  const storeName = isStoreLoading ? LOADING_STORE_LABEL : storeLabel;
  let t1;
  if ($[2] !== setStoreDrawerOpen || $[3] !== storeName) {
    t1 = () => {
      trackSelectStore(storeName);
      setStoreDrawerOpen({
        pageType: "header",
        align: "left",
        showStoreDetails: true
      });
    };
    $[2] = setStoreDrawerOpen;
    $[3] = storeName;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleClick = t1;
  let t2;
  if ($[5] !== handleClick || $[6] !== isStoreLoading || $[7] !== storeLabel || $[8] !== storeName) {
    t2 = <Button variant="link" className="header-store-locator__link" iconName="pin-outline" aria-busy={isStoreLoading} aria-label={storeName} title={storeName} hideText={isStoreLoading} text={storeLabel} onClick={handleClick} />;
    $[5] = handleClick;
    $[6] = isStoreLoading;
    $[7] = storeLabel;
    $[8] = storeName;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== isStoreLoading) {
    t3 = isStoreLoading && <SkeletonBar className="header-store-locator__loader" aria-hidden={true} />;
    $[10] = isStoreLoading;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t2 || $[13] !== t3) {
    t4 = <div className="header-store-locator__group">{t2}{t3}</div>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== hoursLabel || $[16] !== hoursStatus || $[17] !== isStoreLoading || $[18] !== store) {
    t5 = store && !isStoreLoading && <span className={cn("header-store-locator__hours sparky-c-text-passage", {
      "header-store-locator__hours--open": hoursStatus === "open",
      "header-store-locator__hours--closed": hoursStatus === "closed"
    })}>{hoursLabel}</span>;
    $[15] = hoursLabel;
    $[16] = hoursStatus;
    $[17] = isStoreLoading;
    $[18] = store;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  let t6;
  if ($[20] !== t4 || $[21] !== t5) {
    t6 = <div className="header-store-locator">{t4}{t5}</div>;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
}